import styled from "styled-components";

export const ContentCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: 3px;
    border: 2px solid rgba(95, 112, 150, 0.3);
    background-color: rgba(20, 26, 39, 0.5);
    padding: 10px;
    box-sizing: border-box;
    background-image: url("/static/images/big-screen/electric-wheel/card-border.png");
    background-size: 100% 100%;
`;

export const Title = styled.div`
    flex: 0 0 auto;
    display: flex; 
    flex-direction: row;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    box-sizing: border-box;
`;

export const TitleCn = styled.div`
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 4px;
`;

export const TitleEn = styled.div`
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 2px;
`;

export const TitleSeparator = styled.div`
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 1px;
    margin: 0px 10px ;
`;

export const Content = styled.div`
    flex: 1 1 0px;
    overflow: hidden;
`;

